 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"canvg":"canvg","common":"common","modules-job-seeker-job-seeker-module":"modules-job-seeker-job-seeker-module","default~modules-admin-admin-module~modules-dashboard-dashboard-module~modules-digital-portfolio-digi~b8336062":"default~modules-admin-admin-module~modules-dashboard-dashboard-module~modules-digital-portfolio-digi~b8336062","modules-digital-portfolio-digital-portfolio-module":"modules-digital-portfolio-digital-portfolio-module","default~modules-admin-admin-module~modules-job-admin-job-admin-module~modules-supervisor-admin-super~f1547727":"default~modules-admin-admin-module~modules-job-admin-job-admin-module~modules-supervisor-admin-super~f1547727","modules-job-admin-job-admin-module":"modules-job-admin-job-admin-module","modules-supervisor-admin-supervisor-admin-module":"modules-supervisor-admin-supervisor-admin-module","modules-dashboard-dashboard-module":"modules-dashboard-dashboard-module","default~modules-settings-settings-module~modules-whatsapp-whatsapp-module":"default~modules-settings-settings-module~modules-whatsapp-whatsapp-module","default~modules-settings-settings-module~profile-profile-module":"default~modules-settings-settings-module~profile-profile-module","modules-settings-settings-module":"modules-settings-settings-module","modules-whatsapp-whatsapp-module":"modules-whatsapp-whatsapp-module","dompurify":"dompurify","modules-attendance-tracker-attendance-tracker-module":"modules-attendance-tracker-attendance-tracker-module","modules-billing-billing-module":"modules-billing-billing-module","modules-call-analysis-debug-call-analysis-debug-module":"modules-call-analysis-debug-call-analysis-debug-module","modules-credits-credits-module":"modules-credits-credits-module","modules-employer-employer-module":"modules-employer-employer-module","modules-enterprise-admin-enterprise-admin-module":"modules-enterprise-admin-enterprise-admin-module","modules-invoices-invoices-module":"modules-invoices-invoices-module","modules-payment-tracker-payment-tracker-module":"modules-payment-tracker-payment-tracker-module","modules-referrals-referrals-module":"modules-referrals-referrals-module","modules-reports-reports-module":"modules-reports-reports-module","modules-roles-permissions-roles-permissions-module":"modules-roles-permissions-roles-permissions-module","modules-subscription-plans-subscription-plans-module":"modules-subscription-plans-subscription-plans-module"}[chunkId]||chunkId) + "-es2015." + {"canvg":"cdbab72c6b1e93364587","common":"4ae12d4708e9f58fc7b9","modules-job-seeker-job-seeker-module":"1a4d52ce7daa25f6efb7","default~modules-admin-admin-module~modules-dashboard-dashboard-module~modules-digital-portfolio-digi~b8336062":"07010f146513cf5d2e2a","modules-digital-portfolio-digital-portfolio-module":"db000afb7e5f104e8af2","default~modules-admin-admin-module~modules-job-admin-job-admin-module~modules-supervisor-admin-super~f1547727":"62f9de98e0641302f6dc","modules-job-admin-job-admin-module":"28f54c667c3ad7bae026","modules-supervisor-admin-supervisor-admin-module":"0c378bd9c6d5d746f244","modules-dashboard-dashboard-module":"558260dc4f0b9a4fbde8","default~modules-settings-settings-module~modules-whatsapp-whatsapp-module":"f21cd74ff2055fd01b64","default~modules-settings-settings-module~profile-profile-module":"fb52422fce6caf71f671","modules-settings-settings-module":"8f6c1da5b6041622996d","modules-whatsapp-whatsapp-module":"b13af70467cf15627cb3","dompurify":"3c1e805deb19f1962204","modules-attendance-tracker-attendance-tracker-module":"920783632167b692e80e","modules-billing-billing-module":"c519ee1950930d496008","modules-call-analysis-debug-call-analysis-debug-module":"d2c579f3f7909200d2dd","modules-credits-credits-module":"e93ba9f47414147b60a5","modules-employer-employer-module":"92b324b3738f61d7e493","modules-enterprise-admin-enterprise-admin-module":"4e586d1ea2b138ac1218","modules-invoices-invoices-module":"75c44dcd5d56ad66c309","modules-payment-tracker-payment-tracker-module":"394b133f059b8c9b2158","modules-referrals-referrals-module":"eb913a45ff07cdcfc097","modules-reports-reports-module":"2039a48cd1e41e231bc6","modules-roles-permissions-roles-permissions-module":"eff5e9f635dc084ec058","modules-subscription-plans-subscription-plans-module":"38551f6930b1265a1552"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
